<script setup>
import { useMsgStore } from '@/store/msgStore'
import router from '@/router'
import { computed } from 'vue';
const msgStore = useMsgStore()
const items_list = msgStore.totalPages

const router_path = computed(() => router.currentRoute.value.path)

const on_item_click = (item) => {
    if (item.path && item.name) {
        router.push(`${item.path}?name=${item.name}`)
    } else if (item.url) {
        window.open(item.url)
    }
}

const on_login_click = () => {
    router.push('/private_home')
}

const onJumpWeChat = () => {
    window.open('https://lnlin.com/')
}

const onJumpLnlin = () => {
    window.open('https://lnlin.com/')
}

const onJumpBeianMiit = () => {
    window.open('https://beian.miit.gov.cn/')
}

const onJumpBeianGov = () => {
    window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802013142')
}
</script>

<template>
    <v-slide-y-transition>
        <v-app-bar class="bg-transparent" height="90" scroll-behavior="hide" elevation="0">
            <div class="d-flex align-center justify-space-between h-100 w-100 gradient-background">
                <v-btn class="ms-6" variant="plain" icon @click="on_login_click">
                </v-btn>
                <div>
                    <v-avatar class="me-12" size="48">
                        <v-img src="avatar.jpg"></v-img>
                    </v-avatar>
                    <v-btn-toggle mandatory :model-value="router_path" variant="text">
                        <v-btn v-for="item, index in items_list" :key="index" :value="item.path"
                            @click="on_item_click(item)" class="mx-2 text-body-1 rounded-lg">
                            {{ item.name }}
                        </v-btn>
                    </v-btn-toggle>
                </div>
                <v-btn class="me-6" icon @click="on_login_click" disabled>
                </v-btn>
            </div>
        </v-app-bar>
    </v-slide-y-transition>
    <div>
        <router-view></router-view>
    </div>
    <v-footer>
        <v-card class="w-100" variant="text">
            <v-card-actions class="align-start">
                <div v-for="item, index in msgStore.totalPages" :key="index">
                    <v-card class="text-center mx-4" variant="text">
                        <v-card-subtitle>
                            <v-btn class="text-h6 rounded-pill font-weight-black" :to="item.path"
                                width="120" size="x-large" variant="plain" block>
                                {{ item.name }}
                            </v-btn>
                        </v-card-subtitle>
                        <v-card-subtitle v-for="e in item.items" :key="e.name">
                            <v-btn class="mt-2 rounded-pill" width="90" variant="plain" :to="e.path">
                                {{ e.name }}
                            </v-btn>
                        </v-card-subtitle>
                    </v-card>
                </div>
            </v-card-actions>
            <v-card-item class="pa-0 pt-6">
                <div class="d-flex align-center">
                    <v-btn variant="plain" @click="onJumpLnlin">
                        @小林通的奇幻世界
                    </v-btn>
                    <v-btn icon="mdi-wechat" variant="plain" @click="onJumpWeChat"></v-btn>
                    <v-btn icon="mdi-email-outline" variant="plain" @click="onJumpWeChat"></v-btn>
                </div>
                <template v-slot:append>
                    <div class="d-flex align-center">
                        <v-btn variant="plain" @click="onJumpBeianMiit">
                            浙ICP备2022016622号
                        </v-btn>
                        <v-btn variant="plain" @click="onJumpBeianGov">
                            <v-avatar class="mr-2" size="20">
                                <v-img src="beian.png"></v-img>
                            </v-avatar>
                            浙公网安备 33010802013142号
                        </v-btn>
                    </div>
                </template>
            </v-card-item>
        </v-card>
    </v-footer>
</template>

<style>
.gradient-background {
    background: linear-gradient(to bottom, #00000066, #ffffff00);
}
</style>